import { PlusOutlined } from "@ant-design/icons"
import { current, unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Col,
  Form,
  message,
  notification,
  Row,
  Space,
  Table,
} from "antd"
import React, { ReactElement, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styles from "./schoolclinic.module.css"
import moment from "moment"
import Doctorpng from "./image/doctor.png"
import Medicinepng from "./image/medicine.png"
import Unitpng from "./image/unit.png"
import Waterpng from "./image/water.png"
import Nursepng from "./image/nurse.png"
import EasyOnepng from "./image/easyOne.png"
import EasyTwopng from "./image/easyTwo.png"
import EasyThreepng from "./image/easyThree.png"
import EasyFourpng from "./image/easyFour.png"
import EasyFivepng from "./image/easyFive.png"
import EasySixpng from "./image/easySix.png"
import EasySevenpng from "./image/easySeven.png"
import EasyEightpng from "./image/easyEight.png"
import EasyNinepng from "./image/easyNine.png"
import EasyTenpng from "./image/easyTen.png"
import { useHistory } from "react-router-dom"
import { RootDispatch } from "../../app/store"
import { getUserList } from "../user/userSlice"
import axios from "axios"
import { AXIOS_IP_WATER } from "../filingManagement/fileUploadService"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import { pageStoresearch, selectStoresearchData } from "../storesearch/storesearchSlice"
import { DateTimeFormat } from "../../models/datetime"
import { getTenantCategoryName } from "../../models/tenant"
import { selectTenantCategory } from "../../app/applicationSlice"
import { traceRoute } from "../../layouts/layoutSlice"
import { Category } from "../../models/category"

export const SchoolClinicHome = (): ReactElement => {
  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const tenantCategory = useSelector(selectTenantCategory)

  const [userList, setUserList] = useState<any>() //人员

  const [doctorTotal, setDoctorTotal] = useState<any>(0) //医生数量

  const [nurseTotal, setNurseTotal] = useState<any>(0) //护士数量

  const [childTotal, setChildTotal] = useState<any>(0) //保育员数量

  const data = useSelector(selectStoresearchData) //过期药品数量

  const [drinkingWaterTime, setDrinkingWaterTime] = useState<any>() //最近一次申报饮用水日期

  const topData = useMemo(() => [
    {
      id: 1,
      name: "单位类型",
      title: getTenantCategoryName(tenantCategory) + "(卫生所)",
      icon: Doctorpng,
    },
    {
      id: 2,
      name: "医生/护士/保育员",
      title: doctorTotal + '/' + nurseTotal + '/' + childTotal,
      icon: Unitpng,
    },
    {
      id: 4,
      name: "过期药品",
      title: data?.length,
      icon: Medicinepng,
    },
    {
      id: 5,
      name: "最近一次申报饮用水",
      title: drinkingWaterTime,
      icon: Waterpng,
    },
  ], [doctorTotal, nurseTotal, data, drinkingWaterTime, tenantCategory]
)

  const centerDataTop = [
    {
      id: 1,
      title: "库存查询",
      icon: EasyOnepng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: "库房工作站",
            path: "/storesearch",
            state: { flag: 0 },
          })
        )
      },
    },
    {
      id: 2,
      title: "库存流水",
      icon: EasyTwopng,
      onclick: () => { 
        dispatch(
          traceRoute({
            name: '库房工作站',
            path: '/InventoryChange',
          })
        )
      },
    },
    {
      id: 3,
      title: "库存报表",
      icon: EasyThreepng,
      onclick: () => { 
        dispatch(
          traceRoute({
            name: '库存报表',
            path: '/wareHouseStatement',
          })
        )
      },
    },
    {
      id: 4,
      title: "购入入库",
      icon: EasyFourpng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: "库房工作站",
            path: "/putstorage",
            state: {
              category: Category.GRRK,
            },
          })
        )
      },
    },
    {
      id: 5,
      title: "领用出库",
      icon: EasyFivepng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: "库房工作站",
            path: "/putstorage",
            state: {
              category: Category.LYCK,
            },
          })
        )
      },
    },
  ]

  const centerDataBottom = [
    {
      id: 6,
      title: "饮用水",
      icon: EasySixpng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: '饮用水',
            path: '/drinkingWater',
          })
        )
      },
    },
    {
      id: 7,
      title: "商品管理",
      icon: EasySevenpng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: '库房工作站',
            path: '/storage/station',
            state: {
              station: '5',
            },
          })
        )
      },
    },
    {
      id: 8,
      title: "员工管理",
      icon: EasyEightpng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: '机构管理',
            path: '/tenant/manager',
          })
        )
      },
    },
    {
      id: 9,
      title: "机构管理",
      icon: EasyNinepng,
      onclick: () => {
        dispatch(
          traceRoute({
            name: '机构管理',
            path: '/tenant/manager',
          })
        )
      },
    },
    // {
    //   id: 10,
    //   title: "通知公告",
    //   icon: EasyTenpng,
    // },
  ]

  useEffect(() => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }, [])

  useEffect(() => {
    if (userList?.length) {
      setDoctorTotal(
        userList?.filter((v: any) => v?.stationCategory == 1)?.length
      )
      setNurseTotal(
        userList?.filter((v: any) => v?.stationCategory == 0)?.length
      )
      setChildTotal(
        userList?.filter((v: any) => v?.stationCategory == 17)?.length
      )
    }
  }, [userList])

  useEffect(() => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        axios({
          url: `${AXIOS_IP_WATER}/drinkingWater/lastApplicationTime`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
        }).then((res) => {
          setDrinkingWaterTime(res.data.data)
        })
      })
  }, [])

  useEffect(() => {
    dispatch(
      pageStoresearch({
        state: 1,
        size: 1000,
        current: 1,
        deadlineEnd: moment().format(DateTimeFormat),
        registrationTimeTail: moment().format(DateTimeFormat),
      })
    )
  }, [])

  return (
    <>
      <Col
        style={{
          margin: "30px 20px",
          height: "calc(100% - 60px)",
          overflow: "hidden",
        }}
      >
        <div className={styles.homeTopContent}>
          <div className={styles.homeTop}>
            {topData.map((item) => (
            <div className={styles.homeTopItem} key={item.id}>
              <img src={item.icon} alt="" className={styles.homeTopItemIcon} />
              <div className={styles.homeTopItemContent}>
                <span>{item.name}</span>
                <span className={styles.homeTopItemContentTitle}>
                  {item.id == 5 ? item.title || '-' : item.title}
                </span>
              </div>
            </div>
          ))}
          </div>
        </div>
        <div className={styles.homeCenter}>
          <div className={styles.homeCenterTitle}>- 快捷入口 -</div>
          <div className={styles.homeCenterContent}>
            {centerDataTop.map((item) => (
              <div
                className={styles.homeCenterContentItem}
                key={item.id}
                onClick={() => item.onclick && item.onclick()}
              >
                <img
                  src={item.icon}
                  alt=""
                  className={styles.homeCenterItemContentIcon}
                />
                <div className={styles.homeCenterContentItemTitle}>
                  {item.title}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.homeCenterContent}>
            {centerDataBottom.map((item) => (
              <div
                className={styles.homeCenterContentItem}
                key={item.id}
                onClick={() => item.onclick && item.onclick()}
              >
                <img
                  src={item.icon}
                  alt=""
                  className={styles.homeCenterItemContentIcon}
                />
                <div className={styles.homeCenterContentItemTitle}>
                  {item.title}
                </div>
              </div>
            ))}
            <div className={styles.homeCenterContentItem} style={{ background: 'transparent' }}></div>
          </div>
        </div>
      </Col>
    </>
  )
}
